import { render, staticRenderFns } from "./put-away.vue?vue&type=template&id=6798d530&"
import script from "./js/put-away.js?vue&type=script&lang=js&"
export * from "./js/put-away.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports